import {
  Button, Dialog, Modal, useKeyboardEvent,
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { useTranslation } from 'react-i18next';

type TDeleteModalParams = {
  onClose: () => void,
  onSubmit: () => void;
};

export const HierchyAfterUnpackedActiveModal = ({
  onClose,
  onSubmit,
}: TDeleteModalParams) => {
  const { t } = useTranslation();
  useKeyboardEvent('Enter', onSubmit);

  return (
    <Modal
      centered
      visible
      onEscape={onClose}
    >
      <Dialog
        dialog={{
          heading: t(translations.hierarchy_unpacked),
          content: t(translations.hierarchy_unpackedActiveArchive),
          footer: (
            <>
              <Button
                label={t(translations.yes)}
                colored="red"
                onClick={onSubmit}
              />
              <Button label={t(translations.no)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};
